import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { itemRouteBuilder, NamedRts } from "@/router";
import { JSConn } from "@/utilities/js-conn";
import { sellContractsController } from "@/controllers/sellContracts";
import { SellContract } from "@/models/SellContract";

export default defineComponent({
  name: "sellContractPrint",
  props: {
    sellContractId: {
      type: String,
      required: true,
    },
  },
  components: {
    LoadingAnimation,
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage = ref("Loading Inventory Lot...");

    const showRouteBuilder = () => {
      return itemRouteBuilder(
        NamedRts.sellContractDetails,
        props.sellContractId,
      );
    };

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.sellContractId,
      };

      Promise.all([sellContractsController.needSellContract(jsConn)]).finally(
        () => {
          dataLoaded.value = true;
        },
      );
    });

    const sellContract = computed(() => {
      return $store.getters.sellContract as SellContract;
    });

    return {
      sellContract,

      dataLoaded,
      loadingMessage,
      showRouteBuilder,
    };
  },
});
